module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFASURBVFiFxZZrkoQgDIQba++13Ew8Gc7Jsj8WZyIPIRCYVFlaFKY/0zFqMDGIyAKwAH7D+YoDAIwxbqo4EXlqC10QoXgcfoW4D4elf5tARC4cPOxU8UounqdeFU3xTN53jACIxTMaZRBK/VMVr4JUKqAmHundQQpVUBePQLim+wnrO9tzAjiMMecsiBayseEi001s4X1hF0EkD7/h/jH6RrwAJBVxK5QTW8Li7TWaDVPqyS28HQfbuy+szitZKcwSdaCsLQIYCr00BFWypRfogrKDIE56YwlKPPyabOmEssL7ux8il9D3JOy25SGh7QQZt+UpaYs9LbZsnSwnu95LmwqRDrHeoNYf389+fVtYct609mGfbpNmBJqqEvWTPkgQ8U8iLU2qBVL8haCB4dcLU/suzbNECLMGIoLhPeMlEH+4r6fD2CVHJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Vector.png
// module id = f1dQ
// module chunks = 2